module.exports = __webpack_public_path__ + "static/img/ent-92.38d4cba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-92.jpg
// module id = xhkG
// module chunks = 51